import axiosClient from '../api/axiosClient';

/**
 * Right-panel Makeup Look generator (standalone from left panel)
 * Uses existing backend pipeline:
 * - Node: POST /api/makeup/generate
 * - Python: /generate-makeup (in hairchitech_hairstyle_service.py)
 */
export async function generateMakeupLook({ scanId, prompt, variants = 1 }) {
  const zeroIntensities = {
    lip: 0,
    eye: 0,
    concealer: 0,
    blush: 0,
    highlighter: 0,
    brow: 0,
    liner: 0
  };

  const response = await axiosClient.post('/makeup/generate', {
    scanId,
    presetIds: [],
    // Send as lookPrompt so Python uses it as PRIMARY prompt (Haircuts Studio style)
    lookPrompt: prompt,
    customPrompt: '',
    intensities: zeroIntensities,
    variants,
    activeRegion: 'all',
    useClientMasks: false
  });

  return response?.data;
}

